var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationOptional({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F39C12",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.134 10.5C24.5189 9.83333 25.4811 9.83333 25.866 10.5L37.9904 31.5C38.3753 32.1667 37.8942 33 37.1244 33H12.8756C12.1058 33 11.6247 32.1667 12.0096 31.5L24.134 10.5Z",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 29,
    r: 2,
    fill: "#F39C12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15V25",
    stroke: "#F39C12",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationOptional);
export default __webpack_public_path__ + "static/media/validation_optional.fd8a4fb2212298980e79bd0d25f95b98.svg";
export { ForwardRef as ReactComponent };